import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { SliceFlexRenderModule } from 'extensions/core/slice-flex/front/slice-flex-render.module';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';
import { SharedModule } from 'shared/shared.module';

import { SliceDragRenderComponent } from 'extensions/st/slice-drag/front/render/slice-drag-render.component';
import { SliceDragEventsService } from 'extensions/st/slice-drag/front/services/slice-drag-events.service';
import { SubscribeNewsletterService } from 'extensions/st/slice-drag/front/services/subscribe-newsletter.service';
import { SliceDragCloseComponent } from 'extensions/st/slice-drag/front/slice-drag-close/slice-drag-close.component';


export const sliceDragRenderModuleEntryComponents = [
  SliceDragRenderComponent,
  SliceDragCloseComponent
];

@NgModule({
  imports: [
    LazyLoadModule,
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
    DragDropModule,
    SliceFlexRenderModule
  ],
  providers: [
    SliceDragEventsService,
    SubscribeNewsletterService
  ],
  exports: [
    sliceDragRenderModuleEntryComponents
  ],
  declarations: sliceDragRenderModuleEntryComponents
})
export class SliceDragRenderModule {}

export default sliceDragRenderModuleEntryComponents;
